module.exports = __webpack_public_path__ + "img/dashboard_black.d5eeaa42.svg";